/* Kanful 商品詳細
 * - サムネ切替（メイン画像差し替え + ズーム用 src 同期）
 * - メイン画像クリックで拡大モーダル（1200px 原寸）
 * - 拡大モーダルで前後ナビ（ボタン / ←→キー / スワイプ）
 * - 拡大モーダルで部分拡大（ピンチズーム + ドラッグパン + ダブルタップ / デスクトップは wheel）
 */
(function () {
  'use strict';

  function init() {
    var gallery = document.querySelector('[data-kf-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-kf-gallery-main]');
    var zoomTrigger = gallery.querySelector('[data-kf-zoom-open]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-kf-gallery-thumb]'));
    var modal = document.querySelector('[data-kf-zoom-modal]');
    var modalImg = modal ? modal.querySelector('[data-kf-zoom-img]') : null;
    var modalClose = modal ? modal.querySelector('[data-kf-zoom-close]') : null;
    var modalPrev = modal ? modal.querySelector('[data-kf-zoom-prev]') : null;
    var modalNext = modal ? modal.querySelector('[data-kf-zoom-next]') : null;
    var modalIndexLabel = modal ? modal.querySelector('[data-kf-zoom-index]') : null;

    /* ---- 画像リスト構築 ---- */
    var images = thumbs.map(function (thumb) {
      return {
        src: thumb.dataset.src || '',
        srcset: thumb.dataset.srcset || '',
        alt: thumb.dataset.alt || ''
      };
    });
    var currentIndex = 0;

    function applyThumbState(index) {
      thumbs.forEach(function (t, i) {
        if (i === index) t.classList.add('is-active');
        else t.classList.remove('is-active');
      });
    }

    function showImage(index) {
      if (!images.length) return;
      var total = images.length;
      currentIndex = ((index % total) + total) % total;
      var img = images[currentIndex];

      if (main) {
        main.src = img.src;
        if (img.srcset) main.srcset = img.srcset;
        main.alt = img.alt;
      }
      if (zoomTrigger) {
        zoomTrigger.dataset.zoomSrc = img.src;
        zoomTrigger.dataset.zoomAlt = img.alt;
      }
      if (modal && !modal.hidden && modalImg) {
        modalImg.src = img.src;
        modalImg.alt = img.alt;
        resetZoom();
      }
      if (modalIndexLabel) modalIndexLabel.textContent = String(currentIndex + 1);
      applyThumbState(currentIndex);
    }

    /* ---- サムネ切替 ---- */
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        showImage(i);
      });
    });

    /* ---- 拡大モーダル ---- */
    if (!modal || !modalImg) return;

    /* ==== ズーム state ==== */
    var zoom = { scale: 1, tx: 0, ty: 0, min: 1, max: 4 };
    var DOUBLE_TAP_MS = 300;
    var TAP_MOVE_PX = 10;
    var SWIPE_MIN_PX = 40;
    var SWIPE_MAX_MS = 600;
    var DBL_ZOOM = 2.5;

    function applyTransform() {
      modalImg.style.transform =
        'translate(' + zoom.tx + 'px, ' + zoom.ty + 'px) scale(' + zoom.scale + ')';
      if (zoom.scale > 1.01) modal.classList.add('is-zoomed');
      else modal.classList.remove('is-zoomed');
    }

    function withTransition(fn) {
      modalImg.style.transition = 'transform 0.22s ease';
      fn();
      window.setTimeout(function () {
        modalImg.style.transition = '';
      }, 240);
    }

    function resetZoom(animate) {
      var doReset = function () {
        zoom.scale = 1;
        zoom.tx = 0;
        zoom.ty = 0;
        applyTransform();
      };
      if (animate) withTransition(doReset);
      else doReset();
    }

    function clampPan() {
      var rect = modal.getBoundingClientRect();
      var imgW = modalImg.offsetWidth * zoom.scale;
      var imgH = modalImg.offsetHeight * zoom.scale;
      var maxTx = Math.max(0, (imgW - rect.width) / 2);
      var maxTy = Math.max(0, (imgH - rect.height) / 2);
      zoom.tx = Math.max(-maxTx, Math.min(maxTx, zoom.tx));
      zoom.ty = Math.max(-maxTy, Math.min(maxTy, zoom.ty));
    }

    function toggleTapZoom(clientX, clientY) {
      if (zoom.scale > 1.01) {
        resetZoom(true);
      } else {
        withTransition(function () {
          var rect = modal.getBoundingClientRect();
          var cx = clientX - (rect.left + rect.width / 2);
          var cy = clientY - (rect.top + rect.height / 2);
          zoom.scale = DBL_ZOOM;
          zoom.tx = -cx * (DBL_ZOOM - 1);
          zoom.ty = -cy * (DBL_ZOOM - 1);
          clampPan();
          applyTransform();
        });
      }
    }

    function openZoom() {
      var src = (images[currentIndex] && images[currentIndex].src) ||
                (zoomTrigger && zoomTrigger.dataset.zoomSrc) ||
                (main && main.src) || '';
      var alt = (images[currentIndex] && images[currentIndex].alt) ||
                (zoomTrigger && zoomTrigger.dataset.zoomAlt) || '';
      modalImg.src = src;
      modalImg.alt = alt;
      if (modalIndexLabel) modalIndexLabel.textContent = String(currentIndex + 1);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      resetZoom();
      if (modalClose) modalClose.focus();
    }

    function closeZoom() {
      modal.hidden = true;
      modalImg.src = '';
      document.body.style.overflow = '';
      resetZoom();
    }

    if (zoomTrigger) zoomTrigger.addEventListener('click', openZoom);
    if (modalClose) modalClose.addEventListener('click', closeZoom);
    if (modalPrev) modalPrev.addEventListener('click', function (e) {
      e.stopPropagation();
      showImage(currentIndex - 1);
    });
    if (modalNext) modalNext.addEventListener('click', function (e) {
      e.stopPropagation();
      showImage(currentIndex + 1);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeZoom();
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') closeZoom();
      else if (e.key === 'ArrowLeft' && images.length > 1) { e.preventDefault(); showImage(currentIndex - 1); }
      else if (e.key === 'ArrowRight' && images.length > 1) { e.preventDefault(); showImage(currentIndex + 1); }
      else if (e.key === '0') { e.preventDefault(); resetZoom(true); }
    });

    /* ==== Pointer イベントで ピンチ/パン/スワイプ/タップ ==== */
    var pointers = new Map();
    var gesture = null; // 'pinch' | 'pan' | 'swipe' | null
    var pinchStart = null;
    var panStart = null;
    var swipeStart = null;
    var lastTap = 0;

    modalImg.style.touchAction = 'none';
    modalImg.style.userSelect = 'none';

    modalImg.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      try { modalImg.setPointerCapture(e.pointerId); } catch (_) {}
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pointers.size >= 2) {
        var pts = Array.from(pointers.values()).slice(0, 2);
        pinchStart = {
          dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
          midX: (pts[0].x + pts[1].x) / 2,
          midY: (pts[0].y + pts[1].y) / 2,
          scale: zoom.scale,
          tx: zoom.tx,
          ty: zoom.ty
        };
        gesture = 'pinch';
        panStart = null;
        swipeStart = null;
      } else {
        var p = { x: e.clientX, y: e.clientY };
        if (zoom.scale > 1.01) {
          panStart = { x: p.x, y: p.y, tx: zoom.tx, ty: zoom.ty };
          gesture = 'pan';
        } else {
          swipeStart = { x: p.x, y: p.y, time: Date.now() };
          gesture = 'swipe';
        }
      }
    });

    modalImg.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (gesture === 'pinch' && pinchStart && pointers.size >= 2) {
        var pts = Array.from(pointers.values()).slice(0, 2);
        var dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
        var newScale = Math.max(zoom.min, Math.min(zoom.max, pinchStart.scale * (dist / pinchStart.dist)));
        var midX = (pts[0].x + pts[1].x) / 2;
        var midY = (pts[0].y + pts[1].y) / 2;
        zoom.scale = newScale;
        zoom.tx = pinchStart.tx + (midX - pinchStart.midX);
        zoom.ty = pinchStart.ty + (midY - pinchStart.midY);
        clampPan();
        applyTransform();
      } else if (gesture === 'pan' && panStart) {
        var p = Array.from(pointers.values())[0];
        if (!p) return;
        zoom.tx = panStart.tx + (p.x - panStart.x);
        zoom.ty = panStart.ty + (p.y - panStart.y);
        clampPan();
        applyTransform();
      }
    });

    function handlePointerEnd(e) {
      pointers.delete(e.pointerId);

      // pinch → pan transition (指 1本残った場合)
      if (pointers.size === 1 && gesture === 'pinch') {
        var p = Array.from(pointers.values())[0];
        pinchStart = null;
        if (zoom.scale > 1.01) {
          panStart = { x: p.x, y: p.y, tx: zoom.tx, ty: zoom.ty };
          gesture = 'pan';
        } else {
          gesture = null;
        }
        return;
      }

      if (pointers.size !== 0) return;

      // 全指離した — スワイプ/タップ判定
      var endX = e.clientX, endY = e.clientY;
      if (gesture === 'swipe' && swipeStart) {
        var dx = endX - swipeStart.x;
        var dy = endY - swipeStart.y;
        var dt = Date.now() - swipeStart.time;
        if (Math.abs(dx) < TAP_MOVE_PX && Math.abs(dy) < TAP_MOVE_PX && dt < DOUBLE_TAP_MS) {
          var now = Date.now();
          if (now - lastTap < DOUBLE_TAP_MS) {
            toggleTapZoom(endX, endY);
            lastTap = 0;
          } else {
            lastTap = now;
          }
        } else if (
          Math.abs(dx) > SWIPE_MIN_PX &&
          Math.abs(dx) > Math.abs(dy) &&
          dt < SWIPE_MAX_MS &&
          images.length > 1
        ) {
          if (dx < 0) showImage(currentIndex + 1);
          else showImage(currentIndex - 1);
        }
      } else if (gesture === 'pan' && panStart) {
        var dxp = endX - panStart.x;
        var dyp = endY - panStart.y;
        if (Math.abs(dxp) < TAP_MOVE_PX && Math.abs(dyp) < TAP_MOVE_PX) {
          var now2 = Date.now();
          if (now2 - lastTap < DOUBLE_TAP_MS) {
            toggleTapZoom(endX, endY);
            lastTap = 0;
          } else {
            lastTap = now2;
          }
        }
      }

      gesture = null;
      pinchStart = null;
      panStart = null;
      swipeStart = null;
    }

    modalImg.addEventListener('pointerup', handlePointerEnd);
    modalImg.addEventListener('pointercancel', handlePointerEnd);

    /* ==== Wheel zoom (desktop) ==== */
    modalImg.addEventListener('wheel', function (e) {
      e.preventDefault();
      var rect = modal.getBoundingClientRect();
      var cx = e.clientX - (rect.left + rect.width / 2);
      var cy = e.clientY - (rect.top + rect.height / 2);
      var factor = e.deltaY < 0 ? 1.12 : 1 / 1.12;
      var newScale = Math.max(zoom.min, Math.min(zoom.max, zoom.scale * factor));
      var ratio = newScale / zoom.scale;
      zoom.tx = cx * (1 - ratio) + zoom.tx * ratio;
      zoom.ty = cy * (1 - ratio) + zoom.ty * ratio;
      zoom.scale = newScale;
      clampPan();
      applyTransform();
    }, { passive: false });

    /* ---- ランク説明モーダル ---- */
    var rankModal = document.querySelector('[data-kf-rank-modal]');
    var rankOpenBtn = document.querySelector('[data-kf-rank-modal-open]');
    var rankCloseBtn = rankModal ? rankModal.querySelector('[data-kf-rank-modal-close]') : null;

    function openRankModal() {
      if (!rankModal) return;
      rankModal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (rankCloseBtn) rankCloseBtn.focus();
    }

    function closeRankModal() {
      if (!rankModal) return;
      rankModal.hidden = true;
      document.body.style.overflow = '';
    }

    if (rankOpenBtn) rankOpenBtn.addEventListener('click', openRankModal);
    if (rankCloseBtn) rankCloseBtn.addEventListener('click', closeRankModal);

    if (rankModal) {
      rankModal.addEventListener('click', function (e) {
        if (e.target === rankModal) closeRankModal();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && rankModal && !rankModal.hidden) closeRankModal();
    });

    /* ---- サイズガイドモーダル（fetch + 動的挿入） ----
     * Shopify の X-Frame-Options: DENY で iframe 不可のため、
     * /pages/size-guide の HTML を取得して .kf-size-guide 要素だけ抽出してモーダル内に差し込む。
     */
    var guideModal = document.querySelector('[data-kf-guide-modal]');
    var guideCloseBtn = guideModal ? guideModal.querySelector('[data-kf-guide-close]') : null;
    var guideTitle = guideModal ? guideModal.querySelector('[data-kf-guide-title]') : null;
    var guideContent = guideModal ? guideModal.querySelector('[data-kf-guide-content]') : null;
    var guideLoading = guideModal ? guideModal.querySelector('[data-kf-guide-loading]') : null;
    var guideOpenBtns = document.querySelectorAll('[data-kf-guide-open]');
    var guideCache = {};

    function buildGuideUrl(type, opt) {
      if (type === 'size') return '/pages/size-guide?mode=size';
      if (type === 'measure') {
        var safeOpt = String(opt || '1').replace(/[^0-9,]/g, '') || '1';
        return '/pages/size-guide?mode=hide&opt=' + safeOpt;
      }
      if (type === 'color') return '/pages/color-guide?mode=hide';
      return '/pages/size-guide';
    }

    function guideTitleFor(type) {
      if (type === 'size') return 'サイズについて';
      if (type === 'measure') return '採寸について';
      if (type === 'color') return 'カラーについて';
      return 'ガイド';
    }

    function guideSelectorFor(type) {
      return type === 'color' ? '.kf-color-guide' : '.kf-size-guide';
    }

    function showModalEl() {
      if (!guideModal) return;
      if (typeof guideModal.showModal === 'function') {
        guideModal.showModal();
      } else {
        guideModal.setAttribute('open', '');
        guideModal.style.display = 'block';
      }
      document.body.style.overflow = 'hidden';
    }

    function hideModalEl() {
      if (!guideModal) return;
      if (typeof guideModal.close === 'function') {
        guideModal.close();
      } else {
        guideModal.removeAttribute('open');
        guideModal.style.display = '';
      }
      document.body.style.overflow = '';
    }

    function renderGuideContent(html, type, opt) {
      if (!guideContent) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var source = doc.querySelector(guideSelectorFor(type));
      guideContent.innerHTML = '';
      if (!source) {
        guideContent.textContent = 'コンテンツを読み込めませんでした。';
        return;
      }
      if (type === 'size' || type === 'measure') {
        // size-guide: CSS 表示フィルタを起動
        source.setAttribute('data-sg-mode', type === 'size' ? 'size' : 'hide');
        if (type === 'measure' && opt) {
          String(opt).split(',').map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (id) {
            var el = source.querySelector('#jissun_' + id);
            if (el) el.classList.add('is-sg-visible');
          });
        }
      }
      // color-guide はフィルタ不要（コンテンツそのまま）
      guideContent.appendChild(source);
    }

    function openGuideModal(type, opt) {
      if (!guideModal || !guideContent) return;
      if (guideTitle) guideTitle.textContent = guideTitleFor(type);

      var url = buildGuideUrl(type, opt);
      var cacheKey = url;

      if (guideLoading) guideLoading.hidden = false;
      guideContent.innerHTML = '';
      showModalEl();

      var handle = function (html) {
        if (guideLoading) guideLoading.hidden = true;
        renderGuideContent(html, type, opt);
      };

      if (guideCache[cacheKey]) {
        handle(guideCache[cacheKey]);
        return;
      }

      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          guideCache[cacheKey] = html;
          handle(html);
        })
        .catch(function () {
          if (guideLoading) guideLoading.hidden = true;
          guideContent.textContent = '読み込みに失敗しました。';
        });
    }

    function closeGuideModal() {
      hideModalEl();
      if (guideContent) guideContent.innerHTML = '';
    }

    guideOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-kf-guide-open');
        var opt = btn.getAttribute('data-kf-guide-opt');
        openGuideModal(type, opt);
      });
    });

    if (guideCloseBtn) guideCloseBtn.addEventListener('click', closeGuideModal);

    /* お気に入りは Prime Review アプリブロックへ置き換え（#302）。自前 localStorage 方式は廃止 */

    /* ---- SNS シェア: URL コピー ---- */
    var copyBtn = document.querySelector('[data-kf-copy-url]');
    var copyToast = document.querySelector('[data-kf-copy-toast]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = copyBtn.getAttribute('data-kf-copy-url') || window.location.href;
        var showToast = function () {
          if (!copyToast) return;
          copyToast.hidden = false;
          copyToast.classList.add('is-visible');
          setTimeout(function () {
            copyToast.classList.remove('is-visible');
            setTimeout(function () { copyToast.hidden = true; }, 200);
          }, 1400);
        };
        var fallbackCopy = function () {
          var tmp = document.createElement('textarea');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); } catch (_e) {}
          document.body.removeChild(tmp);
          showToast();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showToast).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
      });
    }

    if (guideModal) {
      // 背景（::backdrop）クリックで閉じる
      guideModal.addEventListener('click', function (e) {
        if (e.target === guideModal) closeGuideModal();
      });
      // ESC（<dialog> cancel）で閉じた後のコンテンツクリア
      guideModal.addEventListener('close', function () {
        if (guideContent) guideContent.innerHTML = '';
        document.body.style.overflow = '';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
